import { render, staticRenderFns } from "./zhcx.vue?vue&type=template&id=14831ebe&scoped=true&"
import script from "./zhcx.vue?vue&type=script&lang=js&"
export * from "./zhcx.vue?vue&type=script&lang=js&"
import style0 from "./zhcx.vue?vue&type=style&index=0&id=14831ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14831ebe",
  null
  
)

export default component.exports